import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import Toggle from 'react-toggle'
class BannerModuleAdd extends React.Component {
  state = {
    banner_img_en: '',
    banner_img_ar: '',
    bannerId: '',
    isData: false,
    Edit: false,
    type: '',
    type_id: '',
    targets: [],
    img: '',
    img1: '',
    for_web: false,
  }

  componentDidMount() {
    if (this.props.match.params.bannerId) {
      this.getBannerModule()
    }
  }

  getBannerModule = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/list-banners', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(async (res) => {
        if (res?.data?.success) {
          const matchItem = res?.data?.data.filter((itm) => itm.id === this.props?.match?.params?.bannerId)

          if (matchItem?.length) {
            const itm = matchItem[0]
            if (itm.type) {
              await this.getTargets(itm.type)
            }
            this.setState({
              ...itm,
            })

            this.setState({ Edit: true })
          }
        }
      })
  }

  getTargets = async (type) => {
    this.setState({
      targets: [],
    })

    let targets = []

    if (type == 'C') {
      await axios
        .get(Constant.getAPI() + '/cruise/list-cruise-masters', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.data.success) {
            for (let item of res.data.data) {
              if (item.is_active) {
                targets.push({
                  id: item.id,
                  name: item.cruise_cat_en,
                })
              }
            }
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else if (type == 'T') {
      await axios
        .get(Constant.getAPI() + '/admin/trip', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.data.success) {
            for (let item of res.data.data) {
              targets.push({
                id: item.id,
                name: item.name_en,
              })
            }
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else if (type == 'O') {
      let list = await axios.get(Constant.getAPI() + '/event-companies/event-companies-list/EVENT', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })

      if (list.status == 200 && list.data) {
        for (let item of list.data.data) {
          if (item.is_active) {
            targets.push({
              id: item.id,
              name: item.company_name || item.company_short_name,
            })
          }
        }
      }
    } else if (type == 'A') {
      let list = await axios.get(Constant.getAPI() + '/event-companies/event-companies-list/ACTIVITY', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })

      if (list.status == 200 && list.data) {
        for (let item of list.data.data) {
          if (item.is_active) {
            targets.push({
              id: item.id,
              name: item.company_name || item.company_short_name,
            })
          }
        }
      }
    } else if (type == 'Y') {
      await axios
        .get(Constant.getAPI() + '/cruise/list-cruise', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.data.success) {
            for (let item of res.data.data) {
              targets.push({
                id: item.id,
                name: item.cruise_name_en,
              })
            }
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else if (type == 'D') {
      await axios
        .get(Constant.getAPI() + '/admin/list-destinations', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.data.success) {
            for (let item of res.data.data) {
              if (item.is_active) {
                targets.push({
                  id: item.id,
                  name: item.destination_address_en,
                })
              }
            }
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else if (type == 'E') {
      await axios
        .get(Constant.getAPI() + '/event/list-events', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.data.success) {
            for (let item of res.data.data) {
              if (item.is_active) {
                targets.push({
                  id: item.id,
                  name: item.event_name_en,
                })
              }
            }
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else if (type == 'S') {
      await axios
        .get(Constant.getAPI() + '/store/list-stores', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.data.success) {
            for (let item of res.data.data) {
              if (
                item.is_active &&
                item.shop_type == 'STORE' &&
                (item.shop_subscription_type == 'both' || item.shop_subscription_type == 'store_order')
              ) {
                targets.push({
                  id: item.id,
                  name: item.shop_name_en,
                })
              }
            }
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else if (type == 'CH') {
      await axios
        .get(Constant.getAPI() + '/chalet/list-chalet', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.data.success) {
            targets = res.data.data.map(
              (itm) =>
                itm.is_active && {
                  id: itm.id,
                  name: itm.name_en + ' / ' + itm.name_ar,
                }
            )
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }

    this.setState({
      targets: targets,
    })
  }

  handleChangeImage = (e) => {
    this.setState({ [e.target.name]: e.target.files?.[0] })
    this.setState({ Edit: false })

    if (e.target.name === 'banner_img_en') {
      this.setState({
        img: URL.createObjectURL(e.target.files[0]),
      })
    } else {
      this.setState({
        img1: URL.createObjectURL(e.target.files[0]),
      })
    }
  }

  handleChange = async (event) => {
    if (event?.target?.name === 'for_web') {
      this.setState({ [event.target.name]: event.target.checked })
    } else {
      this.setState({ [event.target.name]: event.target.value })
    }
    if (event.target.name == 'type') {
      this.setState({ type_id: '' })
      await this.getTargets(event.target.value)
    }
  }

  addBanner = () => {
    var that = this
    var data = new FormData()
    that.setState({ isSaving: true })
    data.append('for_web', this.state.for_web)

    if (this.state.type == 'CH' && this.state.type_id == '') {
      Swal.fire({
        title: 'Please Select the Target Chalet',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return
    }

    if (
      (this.state.banner_img_en?.name && this.state.banner_img_ar?.name !== undefined) ||
      (this.state.id &&
        this.state.banner_img_en &&
        (typeof this.state.banner_img_en === 'string' || this.state.banner_img_en?.name) &&
        this.state.banner_img_ar &&
        (typeof this.state.banner_img_ar === 'string' || this.state.banner_img_ar?.name))
    ) {
      data.append('banner_img_en', this.state.banner_img_en)
      data.append('banner_img_ar', this.state.banner_img_ar)
      data.append('type', this.state.type)
      data.append('type_id', this.state.type_id)
    } else {
      Swal.fire({
        title: 'Please upload image for both the fields',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }

    this.setState({ isData: true })
    if (this.props?.match?.params?.bannerId) {
      data.append('id', this.props?.match?.params?.bannerId)
      axios
        .put(Constant.getAPI() + '/admin/edit-banner', data, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'Banner Updated Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/bannerModule-lists`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/admin/add-banner', data, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'Banner Added Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/bannerModule-lists`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  onSaveData = () => {
    var that = this
    that.setState({ isSaving: true })

    that.addBanner()
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Banner {this.props.match.params.bannerId ? 'Edit' : 'Add'} </h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={`/bannerModule-lists`}> Banner List</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Banner {this.props.match.params.bannerId ? 'Edit' : 'Add'}{' '}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane active"
                        id={'flight_class_add_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        <div className="">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Target Type</label>
                                  <div className="col-sm-9">
                                    <select
                                      name="type"
                                      className="form-control"
                                      onChange={this.handleChange}
                                      value={this.state.type}
                                    >
                                      <option value="">Select Target Type</option>
                                      <option value="C">Cruise Category</option>
                                      <option value="T">Trips</option>
                                      <option value="Y">Cruise</option>
                                      <option value="D">Destination</option>
                                      <option value="O">Offer Listing</option>
                                      <option value="A">Activity Listing </option>
                                      <option value="E">Event Details Page</option>
                                      <option value="S">Store</option>
                                      <option value="CH">Chalet</option>
                                      <option value="EL">External Link</option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              {this.state.type && this.state.type != 'EL' ? (
                                <div className="col-md-6">
                                  <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Target</label>
                                    <div className="col-sm-9">
                                      <select
                                        name="type_id"
                                        className="form-control"
                                        onChange={this.handleChange}
                                        value={this.state.type_id}
                                      >
                                        <option value="">Select Target</option>
                                        {this.state.targets && this.state.targets.length
                                          ? this.state.targets.map((target) => (
                                              <option
                                                key={target.id}
                                                value={target.id}
                                              >
                                                {target.name}
                                              </option>
                                            ))
                                          : null}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              ) : null}

                              {this.state.type === 'EL' ? (
                                <div className="col-md-6">
                                  <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">External Link</label>
                                    <div className="col-sm-9">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="type_id"
                                        id="type_id"
                                        placeholder="External Link"
                                        onChange={this.handleChange}
                                        value={this.state.type_id}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                              <div
                                className="col-md-12"
                                style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                              ></div>
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">For Web</label>
                                  <div className="col-sm-9">
                                    <Toggle
                                      name="for_web"
                                      id="for_web"
                                      onChange={this.handleChange}
                                      checked={this.state.for_web}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div
                                className="col-md-12"
                                style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                              ></div>
                              <div className="col-md-6">
                                <div className="row">
                                  <div className="col-sm-3"> Banner Image: English</div>
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <div>
                                        <input
                                          type="file"
                                          id="img"
                                          name="banner_img_en"
                                          accept="image/*"
                                          className="w-100"
                                          onChange={this.handleChangeImage}
                                        />
                                      </div>
                                      <div style={{ color: 'red' }}>Image height width must be 1160 * 600</div>
                                      <div style={{ color: 'red' }}>Image size should not be more then 1 MB</div>
                                    </div>
                                    {this.state.Edit ? (
                                      <img
                                        height="200px"
                                        src={Constant.getImage() + this.state.banner_img_en}
                                        alt="img"
                                        onError={({ currentTarget }) => {
                                          currentTarget.src = './assets/images/no_image.png'
                                        }}
                                      />
                                    ) : (
                                      <img
                                        height="200px"
                                        src={this.state.img}
                                        alt="img"
                                        onError={({ currentTarget }) => {
                                          currentTarget.src = './assets/images/no_image.png'
                                        }}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="row">
                                  <div className="col-sm-3"> Banner Image: Arabic</div>
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <div>
                                        <input
                                          type="file"
                                          id="img"
                                          name="banner_img_ar"
                                          accept="image/*"
                                          className="w-100"
                                          onChange={this.handleChangeImage}
                                        />
                                      </div>
                                      <div style={{ color: 'red' }}>Image height width must be 1160 * 600</div>
                                      <div style={{ color: 'red' }}>Image size should not be more then 1 MB</div>
                                    </div>
                                    {this.state.Edit ? (
                                      <img
                                        height="200px"
                                        src={Constant.getImage() + this.state.banner_img_ar}
                                        alt="img"
                                        onError={({ currentTarget }) => {
                                          currentTarget.src = './assets/images/no_image.png'
                                        }}
                                      />
                                    ) : (
                                      <img
                                        height="200px"
                                        src={this.state.img1}
                                        alt="img"
                                        onError={({ currentTarget }) => {
                                          currentTarget.src = './assets/images/no_image.png'
                                        }}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card-footer">
                              <div className="row">
                                <div className="text-right col-6 offset-6">
                                  <Link
                                    to={`/bannerModule-lists`}
                                    className="btn btn-outline-secondary m-2 "
                                  >
                                    <i className="icofont icofont-rounded-double-left"></i>
                                    Back
                                  </Link>
                                  {this.state.isData ? (
                                    <button
                                      className="btn btn-grd-disabled mr-2"
                                      disabled
                                    >
                                      Saving...!
                                    </button>
                                  ) : (
                                    <button
                                      onClick={this.onSaveData}
                                      className="btn hor-grd btn-grd-inverse offset-1"
                                    >
                                      <i className="ti-save"></i>Save
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BannerModuleAdd
